// extracted by mini-css-extract-plugin
export default {"card":"DockReviewCard_card__vxsOV","header":"DockReviewCard_header__Lt6wH","body":"DockReviewCard_body__-dca6"};